export default __webpack_public_path__ + "static/media/5.3ab7175f.svg";